import { tv } from 'tailwind-variants'

import { body1, h4 } from '@ui-kit/core/typography'

export const modalSelector = tv({
  slots: {
    button:
      'flex flex-row items-center gap-x-1 self-center rounded-lg bg-transparent px-2.5 py-1 md:py-0',
    text: h4({}),
  },
  variants: {
    disabled: {
      true: {},
      false: {
        button: 'hover:opacity-70 active:opacity-70',
      },
    },
    isSmall: {
      true: {
        text: body1(),
      },
    },
  },
  defaultVariants: {
    disabled: false,
  },
})
